module.exports = __webpack_public_path__ + "image/icon_about_technology.png";